import React from 'react';
import PropTypes from 'prop-types';
import ErgoDataForm from '../../components/ErgoDataForm';
import { formTypes } from '../../models/form';

const DoublePolicyNumber = props => (
  <ErgoDataForm {...props} formType={formTypes.DOUBLE_POLICY_NUMBER} />
);

DoublePolicyNumber.propTypes = {
  localePath: PropTypes.string,
  isValid: PropTypes.bool,
  buttonText: PropTypes.string,
};

DoublePolicyNumber.defaultProps = {
  localePath: '',
  isValid: true,
  buttonText: '',
};

DoublePolicyNumber.contextTypes = {
  t: PropTypes.func,
};

export default DoublePolicyNumber;
